<template>
  <div
    @dragenter.prevent="toggleActive"
    @dragleave.prevent="toggleActive"
    @dragover.prevent
    @drop.prevent="toggleActive"
    :class="{ 'active-dropzone': active }"
    class="dropzone">
    <span>{{ $t('configurator.form.labels.drag_and_drop_file') }}</span>
    <span>{{ $t('configurator.form.labels.or') }}</span>
    <label :for="id" class="cursor--pointer">{{ $t('configurator.form.labels.select_file') }}</label>
    <input type="file" :id="id" class="dropzoneFile" />
  </div>
</template>

<script setup>
// source: https://github.com/johnkomarnicki/vue-3-dropzone
import { ref } from "vue"
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })
const props = defineProps({
  id: {
    type: String,
    default: 'dropzoneFile'
  }
})
// define reactive props
const active = ref(false)
// define methods
const toggleActive = () => {
  active.value = !active.value
}
</script>